<div class="trades-all">
  <h1>BEKB | BCBE OTC-X Abschlüsse</h1>
  <otcx-back-to-home></otcx-back-to-home>
  <div class="trades-table">
    <h5 class="page-title">Abschlüsse der letzten drei Handelstage</h5>
    <otcx-error-or-loading [errorWrapper]="tradesLoader">
      @if (tradesLoader.data$ | async; as dailyTrades) {
        <otcx-tabs>
          @for (dailyTrade of dailyTrades; track dailyTrade; let isInitiallyActive = $first) {
            <otcx-tab
              title="{{dailyTrade.date.toJSDate() | weekdayDate}}"
              [active]="isInitiallyActive">
              @if (dailyTrade.tradesLoader) {
                <otcx-error-or-loading [errorWrapper]="dailyTrade.tradesLoader">
                  @if (dailyTrade.tradesLoader.data$ | async; as trades) {
                    @if (!dailyTrade.tradesLoader.hasEmptyData) {
                      <table>
                        <tr>
                          <th>Titel</th>
                          <th class="align-right">Zeit</th>
                          <th class="align-right">Kurs</th>
                          <th class="align-right">Volumen</th>
                        </tr>
                        @for (trade of trades; track trade) {
                          <tr [ngClass]="{'trades-off-book-tr' : trade.offBook}">
                            <td><a [routerLink]="['/security/', trade.isin]">{{trade.name}}</a></td>
                            <td class="align-right">{{fromApiDate(trade.datetime).toJSDate() | date: "HH:mm"}}</td>
                            <td class="align-right">{{trade.price | number: '.2-2'}}</td>
                            <td class="align-right">
                              @if (trade.offBook) {
                                <small>Off Book</small>
                              }
                              <div>{{trade.volume | number: '.0-0'}}</div>
                            </td>
                          </tr>
                        }
                      </table>
                    } @else {
                      @if (isToday(dailyTrade.date)) {
                        <div class="no-entries" data-test="empty-table-message">Heute gab es noch keine Abschlüsse</div>
                      }
                    }
                  }
                </otcx-error-or-loading>
              }
            </otcx-tab>
          }
        </otcx-tabs>
      }
    </otcx-error-or-loading>
  </div>
</div>
